import { extend, override } from 'flarum/common/extend';
import DiscussionListState from 'flarum/forum/states/DiscussionListState';
import DiscussionListItem from 'flarum/forum/components/DiscussionListItem';
import DiscussionPage from 'flarum/forum/components/DiscussionPage';
import username from 'flarum/common/helpers/username';

// 注意：不 import mithil。Flarum 2 核心启动时会把 mithril 挂为全局变量 m
// （globalThis.m），官方扩展的惯例就是直接使用全局 m 做 hyperscript 调用；
// flarum-webpack-config 并未把 'mithril' 外部化，这里 import 反而会导致构建失败。

// ============================================================
// 本扩展集中存放「讨论列表页」的行为定制，目前有四件事：
//   1. 默认排序改为「最新发布」（前后端配合 extend.php）
//   2. 卡片信息行：去掉「最后回复」，改为「作者 于 xx 发布」
//   3. 卡片右侧数字：始终显示总回复数（而不是未读帖数）
//   4. 打开讨论页即整篇标记已读（不依赖滚动，见下方说明）
// 修改后执行 npm run build 重新生成 dist/forum.js。
// ============================================================

// 1. 覆盖 sortMap：把 newest 提到第一位，使「最新发布」成为讨论列表的默认排序
override(DiscussionListState.prototype, 'sortMap', function () {
  const map = {};

  // 搜索结果页保留 relevance 选项在前
  if (this.params && this.params.q) {
    map.relevance = '';
  }
  map.newest = '-createdAt'; // 默认：最新发布（按发布时间倒序）
  map.latest = '-lastPostedAt'; // 最新回复
  map.top = '-commentCount'; // 最热讨论
  map.oldest = 'createdAt'; // 最晚发布（按发布时间正序）

  return map;
});

// 2. 卡片信息行：非搜索页去掉「最后回复人/时间」，
//    换成「作者 于 发布时间 发布」，让人一眼看清是谁在什么时候发的帖。
extend(DiscussionListItem.prototype, 'infoItems', function (items) {
  // 搜索结果页保留核心的摘要行，不动
  if (this.attrs.params && this.attrs.params.q) return;
  items.remove('terminalPost');
  const discussion = this.attrs.discussion;
  const user = discussion.user();
  const createdAt = discussion.createdAt();
  if (user && createdAt) {
    const time = createdAt.toLocaleString('zh-CN', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
    items.add('firstPostTime', m('span', {
      className: 'DiscussionListItem-firstPost'
    }, username(user), ' 于 ', time, ' 发布'), 100);
  }
});

// 3. 卡片右侧数字：始终显示总回复数。
//    核心逻辑（DiscussionListItem.replyCountItem）在讨论有未读时会改显「未读帖数」
//    （双图标、可点击标记已读、点完成数字跳变），普通用户根本不知道这个数字
//    的含义会随阅读状态变化，观感很怪。override showRepliesCount() 恒返回 true，
//    即强制走总回复数分支。未读状态仍通过整行高亮表达（custom-flarum-styles 的
//    discussion-list-custom.css 已实现），不损失信息。
override(DiscussionListItem.prototype, 'showRepliesCount', function () {
  return true;
});

// 4. 打开讨论页 = 整篇标记已读。
//    核心逻辑只在「滚动让末楼进入视口」时才 PATCH lastReadPostNumber
//    （DiscussionPage.positionChanged ← PostStream 的 scroll/settling 事件）。
//    短帖一屏放得下、根本不用滚动 → 那次保存永远不会发出去 → 红点一直挂着
//    （新版主/从未打开过的私密询盘帖尤其明显）。
//    这里在 DiscussionPage.show() 拿到讨论模型后，直接一次性把已读顶到末楼：
//    “点进去 = 读完”，不再依赖滚动。未读红点的出现逻辑不受影响
//    （新回复/新帖 → lastPostNumber 推进 → 列表红点出现），只是“消除”从
//    滚动触发改为打开即触发。
//    幂等：只有 lastPostNumber > lastReadPostNumber 才发保存，已读的讨论
//    再次打开不会重复 PATCH；游客无 session，直接跳过。
extend(DiscussionPage.prototype, 'show', function (_ret, discussion) {
  if (!app.session.user) return;

  // show() 的第一参是 Discussion 模型（store.find / preloadedApiDocument 均返回模型）；
  // 防御性判断，避免拿到非模型数据时抛错打断页面。
  if (!discussion || typeof discussion.lastPostNumber !== 'function') return;
  const lastPostNumber = discussion.lastPostNumber() || 0;
  const lastReadPostNumber = discussion.lastReadPostNumber() || 0;
  if (lastPostNumber > lastReadPostNumber) {
    discussion.save({
      lastReadPostNumber: lastPostNumber
    });
  }
});